
import { TooltipProvider } from "@/components/ui/tooltip";
import { useBookings } from "./useBookings";
import { BookingCard } from "./BookingCard";

export const BookingsList = () => {
  const {
    userBookings,
    isConfirmingPayment,
    selectedBookingId,
    handleCancelBooking,
    handleConfirmPayment,
  } = useBookings();

  return (
    <TooltipProvider>
      <div className="mt-8">
        <h2 className="text-xl font-semibold mb-6">Your Bookings</h2>
        <div className="bg-white p-6 rounded-lg shadow-sm border border-gray-100">
          {userBookings.length > 0 ? (
            <div className="space-y-4">
              {userBookings.map((booking) => (
                <BookingCard
                  key={booking.id}
                  booking={booking}
                  selectedBookingId={selectedBookingId}
                  isConfirmingPayment={isConfirmingPayment}
                  onCancelBooking={handleCancelBooking}
                  onConfirmPayment={handleConfirmPayment}
                />
              ))}
            </div>
          ) : (
            <p className="text-gray-500 text-center">No bookings yet</p>
          )}
        </div>
      </div>
    </TooltipProvider>
  );
};
